import React from 'react';
import { FootprintsIcon, PaletteIcon, UsersIcon, ArmchairIcon } from 'lucide-react';
const groups = [{
  icon: FootprintsIcon,
  title: 'Dance/movement therapists & trainees',
  body: 'Groups every week, or internship hours to fill: walk in with a full arc that still leaves room for what emerges.'
}, {
  icon: PaletteIcon,
  title: 'Creative arts therapists',
  body: 'Music, drama and art therapists who bring movement into group work and want it held with the same care.'
}, {
  icon: UsersIcon,
  title: 'Recreation therapists',
  body: 'Several groups a day in psych, rehab or long-term care, with a population that changes every week.'
}, {
  icon: ArmchairIcon,
  title: 'Activity professionals',
  body: 'Seated and mixed-ability sessions for eldercare and memory care that go beyond the same songs on repeat.'
}];

/** Shown in the first review slot until real buyer reviews are added. */
export function WhoItsFor() {
  return <section aria-labelledby="who-heading" className="w-full bg-white" data-id="element-380" data-mp="1zpgsljwei9ji">
      <div className="max-w-5xl mx-auto px-5 py-16 sm:py-20" data-id="element-381" data-mp="1zrjh1zhwnum4">
        <div className="text-center" data-id="element-382" data-mp="1vpeo72za720j">
          <p className="text-[11px] font-bold uppercase tracking-[1.6px] text-court-deep" data-id="element-383" data-mp="1vqhh1gg5zej3">
            Who it&apos;s for
          </p>
          <h2 id="who-heading" className="mt-3 font-display font-bold text-ink text-[28px] leading-tight tracking-tight sm:text-5xl" data-id="element-384" data-mp="1lz3ltkv8x0vr">
            Built for the person holding the room
          </h2>
          <p className="mx-auto mt-4 max-w-2xl text-base text-ink-soft" data-id="element-385" data-mp="1bykvc796em4v">
            Written with the rigor of dance/movement therapy, in plain language
            anyone trained to lead groups can use within their own scope of
            practice.
          </p>
        </div>
        <div className="mt-9 grid gap-3 sm:grid-cols-2" data-id="element-386" data-mp="32bipn1s4ozj1">
          {groups.map(g => <div key={g.title} className="flex gap-4 rounded-2xl border border-line bg-white p-5 shadow-card" data-id="element-387" data-mp="2xd7f0ou0ekzr">
              <span className="flex h-11 w-11 flex-none items-center justify-center rounded-full bg-court-soft" data-id="element-388" data-mp="3gh11m348ackl">
                <g.icon className="h-5 w-5 text-court-deep" aria-hidden="true" data-id="element-389" data-mp="3lade5evmuswz" />
              </span>
              <div data-id="element-390" data-mp="37iyx3dlad1sk">
                <h3 className="font-display text-base font-bold text-ink" data-id="element-391" data-mp="37fb4cgno0jew">{g.title}</h3>
                <p className="mt-1 text-sm text-ink-soft" data-id="element-392" data-mp="3cgqmo0ygkbtl">{g.body}</p>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}